import { authCopy } from './auth'

/** The settings page and its Account and Billing tabs (K1). */
export const accountCopy = {
  retry: 'Retry',
  page: {
    title: 'Settings',
    description: 'Your account and billing',
    sections: 'Settings sections',
    tabs: { account: 'Account', billing: 'Billing' },
  },
  account: {
    heading: 'Account',
    username: 'Username',
    userId: 'User ID',
    email: 'Email',
    emailPlaceholder: 'you@example.com',
    role: 'Role',
    systemAdmin: 'System admin',
    edit: 'Edit',
    save: 'Save',
    cancel: 'Cancel',
    loadFailed: 'Could not load your account.',
    refreshFailed: 'Could not refresh your account.',
    emailUpdated: 'Email updated',
    emailFailed: 'Failed to update email — check the address and try again.',
  },
  password: {
    heading: 'Password',
    current: 'Current password',
    next: 'New password',
    confirm: 'Confirm new password',
    mismatch: authCopy.passwordMismatch,
    incorrect: 'Current password is incorrect — check it and try again.',
    failed: 'Failed to update password — try again.',
    updated: 'Password updated',
    submit: 'Update password',
  },
  billing: {
    refreshFailed: 'Could not refresh the billing account.',
    listRefreshFailed: 'Could not refresh billing accounts.',
    status: {
      trialing: 'trialling',
      active: 'active',
      past_due: 'overdue',
      canceled: 'cancelled',
      incomplete: 'incomplete',
      unpaid: 'unpaid',
    },
    expiresToday: 'Expires today',
    daysLeft: (days: number) => `${days}d remaining`,
    upgrade: 'Upgrade plan',
    manage: 'Manage billing',
    overdue: 'Payment overdue — update your payment method.',
    canceled: 'Subscription cancelled — upgrade your plan.',
    trialUsage: 'Trial usage',
    creditsUsed: 'Credits used',
    creditsExhausted: 'Trial credits exhausted — upgrade your plan.',
    creditsLow: 'Trial credits running low — upgrade your plan.',
    currentPeriod: 'Current period',
    periodSpend: 'LLM spend (this month)',
    workspaces: 'Workspaces',
    workspacesHelp: 'Unlinked workspaces cannot run agents.',
    linkedList: 'Linked workspaces',
    noneLinked: 'No workspaces linked yet.',
    linked: 'linked',
    link: 'Link',
    activated: 'Subscription activated',
    loadFailed: 'Could not load this billing account.',
    listFailed: 'Could not load your billing accounts.',
    checkoutFailed: 'Failed to start checkout — try again.',
    portalFailed: 'Failed to open the billing portal — try again.',
    workspaceLinked: 'Workspace linked',
    linkFailed: 'Failed to link workspace — try again.',
    create: {
      intro: 'One billing account can cover several workspaces.',
      name: 'Account name',
      namePlaceholder: 'My organisation',
      submit: 'Create account',
      failed: 'Failed to create billing account — try again.',
    },
  },
} as const
